import React, { Component } from 'react';
import { connect } from 'react-redux';
import { hashHistory } from 'react-router';
import Util from '../../../util'
import NavigatorMain from '../../NavigatorMain';
import './InvestmentPlan.css'
import { getInvestmentHistory } from '../../../action/myAssets/InvestPlanAction.js';
class InvestmentRecord extends Component {
  constructor(props) {
    super(props);
    this.state = {
      deals:[]
    };
  }
  componentWillMount(){
    document.title= "定投记录";
    let { 
      dispatch, 
      planId
    } = this.props;
    let data={
      planId:this.props.location.state.planId,
      pageIndex:1,
      pageSize:10000
    }
    dispatch(getInvestmentHistory(data,this.successCallback1.bind(this)))
  }
  successCallback1(result){
    this.setState({
      deals:result,
    })
  }
  render(){

    return (
        <div className="container" >
          <NavigatorMain>
            <div className="header black">
              <div onClick={hashHistory.goBack}><span className="headerLeftBtn"></span></div>
              <div>定投记录</div>
              <div></div>
            </div>
          </NavigatorMain>
          
          <div className='content '>
            <div className='plan-record-header'>
              <div className='plan-record-item'>扣款日期</div>
              <div className='plan-record-item'>扣款金额 ( 元 ) </div>
              <div className='plan-record-item'>当日净值 ( 元 ) </div>
            </div>
            {
              this.state.deals.map( (item,i) =>{
                return(
                  <div className={i%2==0?'plan-record-wrad1':'plan-record-wrad2'} key={'k'+i}>
                    <div className='plan-record-item'>{Util.returnDate(item.tradeDate)}</div>
                    <div className='plan-record-item'>{`${Util.formatStr(item.tradeAmount)}(${item.capitalState})`}  </div>
                    <div className='plan-record-item'>{Util.formatStr(item.nav)} </div>
                  </div>
                )
              })
            }
          </div>
        </div>
    );
  }
}


function mapStateToProps(state, ownProps) {
  return {
  }
}
export default connect(mapStateToProps)(InvestmentRecord);



// WEBPACK FOOTER //
// ./src/components/myAssets/investPlan/InvestmentRecord.js